<template>
	<div class="comment-wrapper">
		<div class="comment-item" v-for="item in data">
			<div class="content" v-html="item.sendContent"></div>
			<div class="usermsg">
				<div class="user">来自·{{item.sendUserNickName}}的评论</div>
				<div class="publishDate">{{item.createDate}}</div>
				<div class="num">点赞：{{item.likeNum}}</div>
				<div class="num">回复：{{item.replyList?item.replyList.length:0}}</div>
			</div>
		</div>
		<el-pagination
			:hide-on-single-page="true"
		    layout="prev, pager, next"
			@current-change="handleCurrentChange"
		    :total="total">
		  </el-pagination>
		<el-empty v-if="total == 0" :image-size="200"></el-empty>
	</div>
</template>

<script>
import { getCommentList } from '@/api/personal/user'
export default {
  data () {
    return {
      data:[],
	  page: 1,
	  total: 0
    }
  },
  methods: {
    async getList(){
    	const res = await getCommentList()
    	if (res.code === 0) {
			res.data.list.forEach((item)=>{
				item.createDate = new Date(item.createDate).toLocaleString().replaceAll('/','-')
			})
			this.total = res.data.total
    		this.data = res.data.list
    	} else {
    	  this.$message.error(res.msg)
    	}
    },
	handleCurrentChange(val){
		this.page = val
		this.getList()
	},
	getDifferTime(date){
		var publishDate = new Date(date)  
		var currentDate = new Date()  
		if(publishDate.getFullYear()<currentDate.getFullYear()){
			if(currentDate.getFullYear()-publishDate.getFullYear()==1){
				if(publishDate.getMonth() == currentDate.getMonth()){
					return '发布于1年前'
				}else{
					return `发布于${12-publishDate.getMonth()+currentDate.getMonth()}月前`
				}
			}else{
				return '发布于1年前'
			}
			
		}else{
			if(publishDate.getMonth() == currentDate.getMonth()){
				if(publishDate.getDate() == currentDate.getDate()){
					return `发布于${currentDate.getHours()- publishDate.getHours()}小时前`
				}else{
					return `发布于${currentDate.getDate()- publishDate.getDate()}日前`
				}
			}else{
				return `发布于${currentDate.getMonth()-publishDate.getMonth()}月前`
			}
		}
	},
  },
  mounted () {
	this.getList()  
  }

}
</script>

<style lang="scss" scoped>
.comment-wrapper{
	padding: 0 10px;
	.comment-item{
		border-bottom: 1px solid #D4D4E6;
		padding-bottom: 15px;
		.content{
			margin: 5px 0;
			/deep/ p{
				margin: 0;
				padding: 0;
				color: #525254;
			}
		}
		.usermsg{
			font-size: 14px;
			.user{
				color: #FF842E;
				display: inline-block;
				margin-right: 80px;
			}
			.publishDate{
				display: inline-block;
				margin-right: 30px;
				color: #A1A7B0;
			}
			.num{
				color: #A1A7B0;
				display: inline-block;
				margin-right: 30px;
			}
		}
	}

}	

</style>